var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h4',{staticClass:"tmf__process-description"},[_vm._v(" "+_vm._s(_vm.modalDescription)+" "),_c('b',[_vm._v(_vm._s(_vm.email))])])
}
var staticRenderFns = []

export { render, staticRenderFns }